export default __webpack_public_path__ + "static/media/vegan-specialty-stores.7d1ddfd6.png";